import * as Yup from 'yup'
import { TFunction } from 'i18next'

export const getTargetCorrectionPaymentValidation = (
  formatCurrencySymbol: (currency: string) => string,
  currencyForPayments: string,
  t: TFunction,
): Yup.ObjectSchema => {
  return Yup.object().shape({
    resultAmount: Yup.number()
      .moreThan(
        0,
        t('formError.minValue', {
          fieldName: t('appraisalMeeting.targetCorrectionPayment.amount'),
          minAmount: 0,
          currency: formatCurrencySymbol(currencyForPayments),
        }),
      )
      .lessThan(Number.POSITIVE_INFINITY, t('formError.numberInvalid'))
      .required(t('formError.required', { fieldName: t('appraisalMeeting.targetCorrectionPayment.amount') }))
      .nullable(),
    comment: Yup.string()
      .min(2, t('formError.commentLength'))
      .required(t('formError.required', { fieldName: t('appraisalMeeting.targetCorrectionPayment.comment') })),
  })
}
